import React from 'react';
import { MenuItem, ListItemText } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { roles } from '../../../constants';
import { restoreInitialUser, getInitialNavigationPage } from '../../../utils/auth';
import { BUYER_PROFILE_LINKS, SELLER_PROFILE_LINKS } from '../../../constants/links';
import LinkAccountController from './LinkAccount';
import { StyledMobileButton, StyledMobileMenuItem } from './ui';
import { parseBuyerProfileTabs } from '../../../utils/navigation';

const StyledMobileLinkMenuItem = styled(NavLink)`
  display: block;
  padding-left: ${props => `${props.paddingLeft}px` || 0};
  text-decoration: none;
`;

const MobileProfileLinks = ({ isAdminLoggedIn, user }) => (
  <>
    <StyledMobileMenuItem isTitle>
      <ListItemText primary={user.dealership_name} />
    </StyledMobileMenuItem>
    {(user.role === roles.BUYER ? parseBuyerProfileTabs(user) : SELLER_PROFILE_LINKS).map(
      (item, listIndex) => (
        <StyledMobileMenuItem key={listIndex}>
          <StyledMobileLinkMenuItem to={item.to} paddingLeft={10}>
            <ListItemText primary={item.text} />
          </StyledMobileLinkMenuItem>
        </StyledMobileMenuItem>
      )
    )}
    {['seller', 'buyer'].includes(user.role) && <LinkAccountController isMobile />}
    {!isAdminLoggedIn && (
      <StyledMobileMenuItem>
        <StyledMobileButton
          type="button"
          onClick={() => {
            localStorage.clear();
            window.location.href = '/';
          }}
        >
          <ListItemText primary="Log Out" />
        </StyledMobileButton>
      </StyledMobileMenuItem>
    )}
    {isAdminLoggedIn && (
      <StyledMobileMenuItem>
        <StyledMobileButton
          type="button"
          onClick={() => {
            const navLink = getInitialNavigationPage() ?? '/admin/customers';
            restoreInitialUser();
            window.location.href = navLink;
          }}
        >
          <ListItemText primary="Go back to Admin" />
        </StyledMobileButton>
      </StyledMobileMenuItem>
    )}
  </>
);

export default connect(state => ({
  user: state.user.user
}))(MobileProfileLinks);
